module.exports = __webpack_public_path__ + "static/media/chrome-side-image.61ff489b.jpg";